<template>
  <div class="container-fluid pt-3">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  apiServer: 'http"//127.0.0.1:8080'
}
</script>

<style>

body{
    background-color:#FCFCFC;
    padding-bottom: 80px;
}

</style>
